import { getTeamLabelByNumber } from '../../utils/utils'

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'ADJUST_EVENT_TIME' ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'RED_CARD' ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'FOUL' (event) {
      this.setFouls(event)
    },
    'DELAYED_FOUL' (event) {
      this.setFouls(event)
    },
    'START_PERIOD' () {
      this.setIngameProperty({
        property: 'fouls',
        value: {
          home: 0,
          away: 0
        }
      })
    },
    'START_SHOOTOUT' (event) {
      this.setShootoutSeriesFormat()
      this.setPenaltyShootouts(event)
    },
    'PLAYER_ON_PITCH' ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'SECOND_YELLOW_CARD' ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'GOAL' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          value: true
        })
      } else {
        this.setScore(event)
      }
    },
    'SHOOTOUT_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'CANCEL' (event) {
      const { RelatedEventNumber } = event
      const { getEventCache, getCurrentPeriod, getMatchPeriods } = this
      const relatedEvent = getEventCache[RelatedEventNumber]

      if (!relatedEvent) {
        return
      }

      const { EventCode, TeamNumber } = relatedEvent
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (['GOAL', 'SHOOTOUT_MISS', 'MISS'].includes(EventCode) && isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      if (EventCode === 'START_SHOOTOUT') {
        this.deletePenaltyShootoutFlag(getCurrentPeriod)
        this.clearShootoutFlag()
        this.setEventLogPeriod(getCurrentPeriod - 1)
        this.setStatisticPeriod(getCurrentPeriod - 1)
        this.setCurrentPeriod(getCurrentPeriod - 1)
        this.deleteLastPeriod()
      }

      if (['RED_CARD', 'SECOND_YELLOW_CARD', 'ADJUST_EVENT_TIME'].includes(EventCode)) {
        const { extra } = event

        if (!extra) return

        const { team1, team2 } = extra

        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }

      this.setScore(event)
      this.setCanceled(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'POSESSION_1' (event) {
      const { GamePeriod } = event
      const {
        getMatchPeriods,
        homeTeamTitle
      } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (overriddenType === 'shootout') {
        return `${this.$t('football.shootout.possession.title')} / ${homeTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${homeTeamTitle}`
    },
    'POSESSION_2' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, awayTeamTitle } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (overriddenType === 'shootout') {
        return `${this.$t('football.shootout.possession.title')} / ${awayTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${awayTeamTitle}`
    },
    /**
     * @return {string}
     */
    'ADJUST_POINTS' () {
      return this.$t('trader.adjust.score.football')
    },
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods, homeTeamTitle, awayTeamTitle } = this
      const { type, overriddenType } = getMatchPeriods[GamePeriod]
      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      if (!TeamNumber) {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      if (overriddenType === 'shootout') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.penaltyshootout')}`
      }

      if (type === 'overtime') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.overtime.football')}`
      }

      return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.maintime')}`
    },
    'ADJUST_SCORE' (event) {
      return this.$t('trader.adjust.points.title')
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout') return this.$t('trader.win.penaltyshootout')

    if (type === 'overtime') return this.$t('trader.win.overtime.football')

    return this.$t('trader.win.maintime')
  }
}
